<template>
  <div v-if="isDownloading">
    <div class="row justify-content-center text-center" style = "" >
      <origami></origami>
    </div>
    <div class="col"  style="text-align:center">
      <h4>Estamos procesando tu solicitud</h4>
    </div>
  </div>
  <div v-else-if="!isDownloading && sucess">
    <div class="col"  style="text-align:center">
      <i class="zmdi zmdi-assignment-check successIcon"></i>
      <br>
      <h4>Para completar la inscripción deberás ingresar al siguiente enlace:</h4><br>
      <h4><a href="https://monserrat.unc.edu.ar/secundario/ingreso/" target="_blank">https://monserrat.unc.edu.ar/secundario/ingreso/</a></h4><br>
      <h4>Y completar: <br>PASO 1 (realización del pago) y PASO 3 (notificación de preinscripción).<br></h4>
      <br>
      <button class="btn btn-primary" v-on:click="goHome">Ir a inicio</button>
    </div>
  </div>
  <div v-else>
    <div class="row justify-content-center">
    </div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <horizontal-stepper
              :steps="demoSteps"
              @completed-step="completeStep"
              @active-step="isStepActive"
              @stepper-finished="post"
              @clicked-next="yourFunction"
              locale="es"
            ></horizontal-stepper>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HorizontalStepper from "vue-stepper";
import DatosPersonales from "./FormSecundarioSteps/DatosPersonales.vue";
import DatosTutor from "./FormSecundarioSteps/DatosTutor.vue";
import DatosEducativos from "./FormSecundarioSteps/DatosEducativos.vue";
import DatosDocumentos from "./FormSecundarioSteps/DatosDocumentos.vue";
import { mapGetters } from "vuex";
import { HTTPFront, swal } from '../share';
import {Origami}  from 'vue-loading-spinner';

export default {
  components: {
    HorizontalStepper,
    DatosPersonales,
    DatosTutor,
    DatosEducativos,
    DatosDocumentos,
    Origami
  },
  data() {
    return {
      isDownloading:false,
      sucess:false,
      level : null,
      demoSteps: [
        {
          icon: "person",
          name: "first",
          title: "Paso 1",
          subtitle: "Datos personales del aspirante",
          component: DatosPersonales,
          completed: false,
        },
        {
          icon: "supervisor_account",
          name: "second",
          title: "Paso 2",
          subtitle: "Datos del tutor",
          component: DatosTutor,
          completed: false,
        },
        {
          icon: "school",
          name: "third",
          title: "Paso 3",
          subtitle: "Datos de cursado",
          component: DatosEducativos,
          completed: false,
        },
        {
          icon: "attach_file",
          name: "fourth",
          title: "Paso 4",
          subtitle: "Carga de documentos",
          component: DatosDocumentos,
          completed: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getAspirantData","getAspirantDataDocument","getLevel"])
  },
  mounted(){
    if(!this.$route.params.call.documentTypes.length)
    {
      this.demoSteps.pop();
    }
  },
  methods: {
    // Executed when @completed-step event is triggered

    completeStep(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      if(this.getAspirantData[1].length>0){
        this.$emit("can-continue", { value: true });
      }
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    // Executed when @stepper-finished event is triggered
    post() {
      this.isDownloading      = true;
      let aspirantData        = this.getAspirantData;
      let aspirantDocument    = this.getAspirantDataDocument;
      let proposalData        = this.$route.params;
      let academicProposalId  = proposalData.proposal.id;
      let callId              = proposalData.call.id;
      this.level              = this.getLevel;
      var formulario          = new FormData();
      let tutors = [];
      let siblings = [];



      //armamos el arreglo de tutores
      aspirantData[1].forEach(
        (tutor,index)=>{
          tutors[index] = {
            "first_name"                 : this.titleCase(tutor.name),
            "surname"                    : this.titleCase(tutor.lastName),
            "dni_number"                 : tutor.documentNumber,
            "cuil_number"                : tutor.cuilNumber,
            "birth_date"                 : this.$moment(tutor.birthDate).format("YYYY-MM-DD")+'T00:00:00.000Z',                          /*  1990-08-13T14:58:43.849Z */
            "nationality_country_code"   : tutor.nationalitySelected.code_iso_alfa3,
            "address_country_code"       : tutor.actualCountrySelected.code_iso_alfa3,
            "address_province_code"      : tutor.actualProvinceSelected.code_iso,
            "address_locality"           : tutor.location,
            "address_zip_code"           : tutor.postalCode,
            "address_neighborhood"       : tutor.neighborhood,
            "address_street"             : tutor.street,
            "address_street_number"      : tutor.streetNumber,
            "address_floor"              : tutor.floorNumber,
            "address_room"               : tutor.department,
            "address_building"           : tutor.building,
            "address_comment"            : tutor.comment,
            "phones"                     : tutor.phoneNumber,
            "emails"                     : tutor.email,
            "profession"                 : tutor.profession,
            "family_relationship_type_id": tutor.familyRelationshipSelected.id
          }
        }
      );




      let form = {
        aspirant: {
          "first_name"              : this.titleCase(aspirantData[0].name),
          "surname"                 : this.titleCase(aspirantData[0].lastName),
          "dni_number"              : aspirantData[0].documentNumber,
          "cuil_number"             : aspirantData[0].cuilNumber,
          "birth_date"              : this.$moment(aspirantData[0].birthDate).format("YYYY-MM-DD")+'T00:00:00.000Z',                          /*  1990-08-13T14:58:43.849Z */
          "birth_country_code"      : aspirantData[0].countrySelected.code_iso_alfa3,
          "birth_province_code"     : aspirantData[0].provinceSelected.code_iso,
          "birth_locality"          : aspirantData[0].townOfBirth,
          "nationality_country_code": aspirantData[0].nationalitySelected.code_iso_alfa3,
          "address_country_code"    : aspirantData[0].actualCountrySelected.code_iso_alfa3,
          "address_province_code"   : aspirantData[0].actualProvinceSelected.code_iso,
          "address_locality"        : aspirantData[0].location,
          "address_zip_code"        : aspirantData[0].postalCode,
          "address_neighborhood"    : aspirantData[0].neighborhood,
          "address_street"          : aspirantData[0].street,
          "address_street_number"   : aspirantData[0].streetNumber,
          "address_floor"           : aspirantData[0].floorNumber,
          "address_room"            : aspirantData[0].department,
          "address_building"        : aspirantData[0].building,
          "address_comment"         : aspirantData[0].comment,
          "blood_group_id"          : aspirantData[0].bloodGroupSelected.id,
          "blood_factor_id"         : aspirantData[0].bloodFactorSelected.id,
          "gender_id"               : aspirantData[0].genderSelected.id,
          "disability_detail"       : aspirantData[0].hasDisability ? aspirantData[0].disabilityDetail : null
        },
        tutors : tutors,
        siblings : [],
        "preferred_shift_id"     : aspirantData[2].preferredShiftSelected.id,
        "shift_comment"          : aspirantData[2].comment,
        "previous_school"        : aspirantData[2].previousSchool,
        "latest_grade_id"        : aspirantData[2].latestGradeSelected.id,
        "minicourse_shift_id"    : aspirantData[2].hasCourseSelected?aspirantData[2].minicourseSelected.id:null,
        "previous_school_type_id": aspirantData[2].schoolTypeSelected.id
      }

      //armamos arreglo de hermanos
      if(aspirantData[2].hasSiblings){
        aspirantData[2].siblings.forEach(
          (sibling,index)=>{
            siblings[index]={
              "first_name"    : this.titleCase(sibling.name),
              "surname"       : this.titleCase(sibling.lastName),
              "dni_number"    :  sibling.documentNumber,
              "division"      :  sibling.division
            }
          }
        )
        form.siblings = siblings;
      }

      Object.keys(aspirantDocument).forEach(key => {
        aspirantDocument[key].forEach(file=>{
          formulario.append(key,file, file.name);
        })
      });

      formulario.append('form',  JSON.stringify(form));

      this.isDownloading = true;
      HTTPFront.post('/public/academicproposals/' + academicProposalId + '/calls/' + callId + '/forms',
        formulario,

        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType:'blob',

        }
      )
      .then(res => {
        this.downloadBlob(res.data,aspirantData[0].documentNumber+'.pdf')
      })
      .catch(error => {
        //console.log("ERROR:",error.response)
        //console.log("ERROR details:",error.details)
        //console.log("ERROR message:",error.message)

        this.isDownloading = false;
        let status = error.response?error.response.status:500;
        switch (status) {
          case 401:
            swal.fire({title: 'Acceso denegado', text: 'No posee permisos para acceder a este servicio.', type: 'warning' });
            break;
          case 409:
            swal.fire({title: 'Datos no guardados', text: error.response.data?error.response.data:'Hubo un conflicto con tus datos. Intenta nuevamente si el problema persiste, contactate con el administrador del sistema.', type: 'warning' });
            break;
          case 404:
            swal.fire({icon: 'error',title: '¡Oops!', text: error.response.details?error.response.details:'Hubo un conflicto con tus datos. Intenta nuevamente, si el problema persiste, contactate con el administrador del sistema.', type: 'warning' });
            break;
          case 422:
            swal.fire({icon: 'error',title: '¡Oops!', text: error.response.details?error.response.details:'El DNI del aspirante ya se encuentra confirmado para esta propuesta. Solo puede ser confirmado una vez.', type: 'warning' });
            break;
          case 500:
            swal.fire({icon: 'error', title: 'Algo salió mal', text: 'No pudimos completar tu inscripción. Intentá más tarde.', type: 'warning' });
            break;
          default:
            swal.fire({icon: 'error', title: 'Algo salió mal', text: 'El servicio no se encuentra disponible. Intentá más tarde.', type: 'warning' });
            break;
        }
      })
    },
    openOnNewTab(blob) {
      blob = blob.slice(0, blob.size, 'application/pdf');
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    },
    downloadBlob(blob, filename) {
      this.isDownloading = false;
      this.sucess = true;
      const link = document.createElement('a');
      blob = blob.slice(0, blob.size,'application/pdf');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    },
    yourFunction(){
    },
    goHome(){
      this.$router.push('/'+this.level);
    },
    titleCase(str) {
      return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
      }).join(' ');
    }
  },
};
</script>
<style>
.successIcon{
  font-size: 56px;
  color:#31855e;
}
</style>